/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Filter_BtnInputs */

const en_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const es_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const fr_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres`)
};

const de_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const ja_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込み`)
};

const zh_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选`)
};

const ar_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية`)
};

const id_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const it_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri`)
};

const ru_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры`)
};

const pt_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const ko_search_filter_btn = /** @type {(inputs: Search_Filter_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Search_Filter_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_filter_btn = /** @type {((inputs?: Search_Filter_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Filter_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_filter_btn(inputs)
	if (locale === "es") return es_search_filter_btn(inputs)
	if (locale === "fr") return fr_search_filter_btn(inputs)
	if (locale === "de") return de_search_filter_btn(inputs)
	if (locale === "ja") return ja_search_filter_btn(inputs)
	if (locale === "zh") return zh_search_filter_btn(inputs)
	if (locale === "ar") return ar_search_filter_btn(inputs)
	if (locale === "id") return id_search_filter_btn(inputs)
	if (locale === "it") return it_search_filter_btn(inputs)
	if (locale === "ru") return ru_search_filter_btn(inputs)
	if (locale === "pt") return pt_search_filter_btn(inputs)
	return ko_search_filter_btn(inputs)
});